export const DATA_GRID_TEXT = {
	scrollHintLeft: 'Double-click to jump to the very first station',
	scrollHintRight: 'Double-click to jump to the very last station',
	gridTestId: 'ride-details-data-grid',
};
